import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { show, hide } from './busy-indicator-actions';
import './busy-indicator.scss';
import addInterceptors from '../../helpers/busy-indicator-interceptor';

function BusyIndicator(props) {
    const { callCounter } = props.busyIndicatorState;
    if (callCounter < 1) {
        return null;
    }

    return (
        <div className="busy-indicator" />
    );
}

BusyIndicator.propTypes = {
    busyIndicatorState: PropTypes.object
};

function mapStateToProps(state) {
    return {
        busyIndicatorState: state.busyIndicatorReducer
    };
}

function mapDispatchToProps(dispatch) {
    addInterceptors({
        dispatch,
        showAction: show,
        hideAction: hide
    });
    return bindActionCreators({
        show,
        hide
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BusyIndicator);



// WEBPACK FOOTER //
// ./containers/busy-indicator/busy-indicator.js